var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { CheckboxGroup } from '@backrs_ui/common-ui/src/designSystem/checkbox/CheckboxGroup';
import { Box } from '@mui/material';
import { ImageCard } from './ImageCard';
var DescriptionContent = function (_a) {
    var description = _a.description, learnMore = _a.learnMore;
    return (_jsxs(_Fragment, { children: [description, (learnMore === null || learnMore === void 0 ? void 0 : learnMore.text) && (_jsxs(Box, { sx: learnMoreStyles, onClick: learnMore === null || learnMore === void 0 ? void 0 : learnMore.onClick, children: [' ', learnMore.text] }))] }));
};
var CheckBoxSection = function (_a) {
    var _b = _a.checkboxItems, checkboxItems = _b === void 0 ? [] : _b;
    return (_jsx(Box, { sx: checkboxContainer, children: _jsx(CheckboxGroup, { options: checkboxItems.map(function (item) { return ({ label: item, value: item }); }), defaultChecked: true, disabled: true, sxOverrides: cbGroupControlOverrides }) }));
};
export function DataLockedAndLoadedCard(_a) {
    var title = _a.title, description = _a.description, _b = _a.checkboxItems, checkboxItems = _b === void 0 ? [] : _b, learnMore = _a.learnMore, imageUrl = _a.imageUrl, _c = _a.setMinWidth, setMinWidth = _c === void 0 ? true : _c;
    return (_jsx(ImageCard, { imageUrl: imageUrl, title: title, description: _jsx(DescriptionContent, { description: description, learnMore: learnMore }), sxOverrides: sxOverrides(setMinWidth), children: checkboxItems && _jsx(CheckBoxSection, { checkboxItems: checkboxItems }) }));
}
var learnMoreStyles = function (_a) {
    var typography = _a.typography, backrs = _a.backrs;
    return (__assign({ display: 'inline', color: backrs.colors['Brand/600'], cursor: 'pointer' }, typography['text-sm-semibold']));
};
var containerSx = function (setMinWidth) {
    return function (_a) {
        var backrs = _a.backrs;
        return (__assign(__assign(__assign({}, (setMinWidth && {
            minWidth: {
                xs: '100%',
                md: "calc(50% - ".concat(backrs.spacing['spacing-4xl'], ")"),
            },
        })), (!setMinWidth && {
            minWidth: '100%',
        })), { '&:hover': {
                boxShadow: 'none',
                transform: 'none',
            }, cursor: 'default' }));
    };
};
var descriptionSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        color: backrs.colors['Colors/Text/text-primary'],
    });
};
var imageSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        borderBottom: "1px solid ".concat(backrs.colors['Colors/Base/Black']),
        width: 'calc(100% + 2px)',
        marginLeft: '-1px',
        marginRight: '-1px',
    });
};
var sxOverrides = function (setMinWidth) { return ({
    container: containerSx(setMinWidth),
    description: descriptionSx,
    image: imageSx,
}); };
var cbGroupControlOverrides = function (_a) {
    var backrs = _a.backrs, typography = _a.typography;
    return ({
        outline: 'none',
        padding: backrs.spacing['spacing-none'],
        '&.Mui-disabled .MuiFormControlLabel-label': {
            color: backrs.colors['Colors/Base/Black'],
        },
        '& .MuiFormControlLabel-label': __assign(__assign({}, typography['text-xs-regular']), { marginTop: backrs.spacing['spacing-none'], paddingTop: backrs.spacing['spacing-none'] }),
        '& .MuiFormControlLabel-root': {
            display: 'flex',
            marginTop: backrs.spacing['spacing-none'],
            paddingTop: backrs.spacing['spacing-none'],
        },
        '& .MuiCheckbox-root': {
            marginRight: backrs.spacing['spacing-lg'],
            alignSelf: 'flex-start',
        },
        marginLeft: backrs.spacing['spacing-md'],
    });
};
var checkboxContainer = function (_a) {
    var backrs = _a.backrs, typography = _a.typography;
    return (__assign(__assign({ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: backrs.spacing['spacing-lg'] }, typography['text-xs-regular']), { paddingTop: backrs.spacing['spacing-2xl'] }));
};
